import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import Notification from '../Notification/Notification.component'
import { NotificationType } from '../../types/notification.enum'

interface Props {
    notification: NotificationType | null
}

const RegisterNotifications: FC<Props> = ({ notification }) => {
    const { t } = useTranslation()
    return (
        notification && (
            <Notification type={notification}>
                {notification === NotificationType.POSITIVE && t('profile.successfulRegistration')}
                {notification === NotificationType.NEGATIVE && t('errors.errorOnSave')}
                {notification === NotificationType.PD_EMAIL_ERROR && t('errors.pdEmailError')}
                {notification === NotificationType.EMAIL_EXISTS_ERROR && t('errors.emailAlreadyExists')}
            </Notification>
        )
    )
}

export default RegisterNotifications
